export default __webpack_public_path__ + "static/our-community-d534797fa809d5276f0b4e9a3b1ac96d.webp";